/*
 * Collapsible row.
 *
 * <details> can't animate its own close: the moment `open` is removed the
 * content is gone, so the CSS transition has nothing to run against. The fix is
 * to own the toggle — keep `open` set while the closing animation plays, then
 * remove it on transitionend.
 *
 * The `is-open` class (not the `open` attribute) drives the CSS, which keeps
 * markup that renders open by default working before this script loads.
 */
(function () {
  if (window.__vrnCollapsibleRow) return;
  window.__vrnCollapsibleRow = true;

  if (!window.customElements || window.customElements.get('collapsible-row')) return;

  window.customElements.define(
    'collapsible-row',
    class extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.cr-panel');
        if (!this.details || !this.summary || !this.panel) return;

        /* Marks `is-open` as authoritative for the toggle icon. Without this the
           icon has to follow details[open], which stays set for the whole
           closing animation; the stylesheet keeps that as the no-JS path. */
        this.classList.add('cr-js');
        this.classList.toggle('is-open', this.details.open);

        this.onClick = this.onClick.bind(this);
        this.onEnd = this.onEnd.bind(this);
        this.summary.addEventListener('click', this.onClick);
        this.panel.addEventListener('transitionend', this.onEnd);
      }

      disconnectedCallback() {
        if (this.summary) this.summary.removeEventListener('click', this.onClick);
        if (this.panel) this.panel.removeEventListener('transitionend', this.onEnd);
      }

      onClick(event) {
        event.preventDefault();
        /* Read the visual state, not details.open — while a close animation is
           playing `open` is still set, so trusting it would swallow a click
           meant to re-open the row. */
        if (this.classList.contains('is-open')) this.close();
        else this.open();
      }

      open() {
        this.closing = false;
        window.clearTimeout(this.fallback);
        this.details.open = true;
        /* Next frame, so the browser paints the 0fr state before transitioning. */
        window.requestAnimationFrame(
          function () {
            window.requestAnimationFrame(
              function () {
                this.classList.add('is-open');
              }.bind(this)
            );
          }.bind(this)
        );
      }

      close() {
        this.closing = true;
        this.classList.remove('is-open');

        /* If the transition never fires — reduced motion, zero duration, a
           hidden tab — the row would be stuck open. Settle it either way. */
        window.clearTimeout(this.fallback);
        this.fallback = window.setTimeout(
          function () {
            this.settle();
          }.bind(this),
          600
        );
      }

      onEnd(event) {
        if (event.propertyName !== 'grid-template-rows') return;
        this.settle();
      }

      settle() {
        window.clearTimeout(this.fallback);
        if (!this.closing) return;
        this.closing = false;
        this.details.open = false;
      }
    }
  );
})();
